import { makeAutoObservable } from "mobx";
import {
    deleteMedicalEquipment,
    getMedicalEquipmentById,
    pagingMedicalEquipment,
    saveOrUpdateMedicalEquipment
} from 'app/services/MedicalEquipmentService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { MedicalEquipment } from "app/common/Model/MedicalEquipment";
import { checkSearchObject } from "app/common/LocalFunction";
import { downloadTemplateMedicalEquipment, importExcelMedical } from "app/services/ImportExcelService";

const defaultValue = {
    isUsing:true,
    entryDate:new Date(),
    medicalEquipmentAttachFiles:[]
    
}
export default class MedicalEquipmentStore {
    searchMedicalEquipment = new SearchObject();
    pageMedicalEquipment = null;
    selectedMedicalEquipment = defaultValue;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

   

    pagingMedicalEquipment = async () => {
        return await pagingMedicalEquipment(this.searchMedicalEquipment)
            .then(({ data }) => {
                this.pageMedicalEquipment = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu đơn vị tính có lỗi")
            })
    }

    handleChangeFormSearch = (searchMedicalEquipment) => {
        this.searchMedicalEquipment = checkSearchObject(this.searchMedicalEquipment, searchMedicalEquipment);
        this.pagingMedicalEquipment();
    }

    handleOpenFormCreateOrEdit = (medicalEquipmentId) => {
        if (Boolean(medicalEquipmentId)) {
            getMedicalEquipmentById(medicalEquipmentId).then(({ data }) => {
                this.selectedMedicalEquipment = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedMedicalEquipment = new MedicalEquipment();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateMedicalEquipment = (medicalEquipment, { setSubmitting }) => {
        saveOrUpdateMedicalEquipment(medicalEquipment)
            .then(() => {
                this.selectedMedicalEquipment = defaultValue;
                toast.success("Lưu thông tin thành công!");
                this.handleClosePopup();
                this.pagingMedicalEquipment();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu thông tin có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (medicalEquipment) => {
        this.selectedMedicalEquipment = { id: medicalEquipment?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteMedicalEquipment(this.selectedMedicalEquipment?.id)
            .then(() => {
                if (this.searchMedicalEquipment?.pageIndex > 1 && this.pageMedicalEquipment?.content?.length === 1) {
                    this.searchMedicalEquipment.pageIndex -= 1;
                }
                toast.success("Xóa đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingMedicalEquipment();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa đơn vị tính có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchMedicalEquipment = new SearchObject();
        this.pageMedicalEquipment = null;
        this.selectedMedicalEquipment = defaultValue;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    //for choosing
    listMedicalEquipment = [];
    medicalEquipmentIdSet = null;

    idValidMedicalEquipment = medicalEquipment => {
        if (medicalEquipment && (medicalEquipment?.id || medicalEquipment?.medicalEquipmentId)) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addMedicalEquipment = medicalEquipment => {
        if (!this.idValidMedicalEquipment(medicalEquipment)) return;
        this.listMedicalEquipment.push(medicalEquipment);
        this.medicalEquipmentIdSet.add(medicalEquipment?.id || medicalEquipment?.medicalEquipmentId);
    }

    initializeListMedicalEquipment = medicalSupplies => {
        this.medicalEquipmentIdSet = new Set();
        this.listMedicalEquipment = [];
        if (medicalSupplies && medicalSupplies?.length > 0) {
            for (let i = 0; i < medicalSupplies.length; i++) {
                this.addMedicalEquipment(medicalSupplies[i]);
            }
        }
    }

    removeMedicalEquipment = medicalEquipment => {
        if (!this.idValidMedicalEquipment(medicalEquipment)) return;
        if (this.medicalEquipmentIdSet.has(medicalEquipment?.id)) {
            this.medicalEquipmentIdSet.delete(medicalEquipment?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = medicalEquipment => {
        if (!this.idValidMedicalEquipment(medicalEquipment)) return;
        return this.medicalEquipmentIdSet.has(medicalEquipment?.id);
    }

    getMedicalEquipmentIdSet = () => {
        return this.medicalEquipmentIdSet;
    }

    getListMedicalEquipment = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listMedicalEquipment && this.listMedicalEquipment?.length > 0) {
            for (let i = 0; i < this.listMedicalEquipment.length; i++) {
                const medicalEquipment = this.listMedicalEquipment[i];
                if (this.isExist(medicalEquipment) && !bufferIdSet.has(medicalEquipment?.id)) {
                    data.push(medicalEquipment);
                    bufferIdSet.add(medicalEquipment?.id);
                }
            }
        }
        this.listMedicalEquipment = data;
        return data;
    }
    
    handleDownloadExcelTemplate = async () => {
        try {
          const response = await downloadTemplateMedicalEquipment();
    
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TRANG_THIET_BI.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        } catch (error) {
          console.error("Error downloading template:", error);
        }
    }
    //end

    SubmitExcelMedical = (file) => {
        importExcelMedical(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchMedicalEquipment = {
                ...this.searchMedicalEquipment,
                pageIndex:1
            }
            this.pagingMedicalEquipment()

        }).catch(() => {
            toast.error("Nhập excel thất bại")
        })
    }

}
